/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransportRelation } from './TransportRelation';
import {
    TransportRelationFromJSON,
    TransportRelationFromJSONTyped,
    TransportRelationToJSON,
    TransportRelationToJSONTyped,
} from './TransportRelation';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseTransportRelation
 */
export interface ResponseTransportRelation {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseTransportRelation
     */
    result: ResponseResult;
    /**
     * 
     * @type {TransportRelation}
     * @memberof ResponseTransportRelation
     */
    data: TransportRelation;
}

/**
 * Check if a given object implements the ResponseTransportRelation interface.
 */
export function instanceOfResponseTransportRelation(value: object): value is ResponseTransportRelation {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseTransportRelationFromJSON(json: any): ResponseTransportRelation {
    return ResponseTransportRelationFromJSONTyped(json, false);
}

export function ResponseTransportRelationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseTransportRelation {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': TransportRelationFromJSON(json['data']),
    };
}

export function ResponseTransportRelationToJSON(json: any): ResponseTransportRelation {
    return ResponseTransportRelationToJSONTyped(json, false);
}

export function ResponseTransportRelationToJSONTyped(value?: ResponseTransportRelation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': TransportRelationToJSON(value['data']),
    };
}

